module.exports = __webpack_public_path__ + "img/rune.069d912a.svg";